import React from "react";
import {Route} from "react-router-dom";

import DocumentIndex from "./index";

const data = [<Route exact key="DocumentIndex" path="/document/index" element={<DocumentIndex />} />];

export default data;
